
// https://www.freecodecamp.org/news/how-to-write-your-own-custom-mouse-ui-class-in-vanilla-javascript-287115be0729/


/**
 * Mouse
 *
 */
export default class Mouse {


    /**
     *
     * @param parameters
     */
    constructor(parameters) {

        this.div_id = parameters.div_id || 'scene'
        this.debug = parameters.debug || false

        this.mouseDragCallback = parameters.mouseDragCallback || null
        this.mouseUpCallback = parameters.mouseUpCallback || null


        this.current = { x: 0, y: 0 } // Current mouse position on
        // the screen, at any time
        // regardless of state

        this.memory = { x: 0, y: 0 } // Memorized mouse position
        // (for measuring dragging
        // distance)

        this.difference = { x: 0, y: 0 } // Difference

        this.inverse = { x: 0, y: 0 } // Handle negative distance

        this.dragging = false          // Not dragging by default

        this.mouseClick = false

        // Mouse Button Was Clicked!
        document.getElementById(this.div_id).addEventListener("mousedown", (e) => {

            switch (e.button) {
                case 1:
                    this.mouseClick = 'left'
                    break;
                case 2:
                    this.mouseClick = 'middle'
                    break;
                case 3:
                    this.mouseClick = 'right'
                    break;
                default:
                    this.mouseClick = false
            }

            if (this.debug) console.log('-> mouse : down ' + this.mouseClick)

            // We are not currently dragging
            if (this.dragging == false) {

                // Start tracking dragging coordinates
                this.dragging = true

                // Memorize mouse click location
                this.memory.x = this.current.x
                this.memory.y = this.current.y

                // Reset inverse coordinates
                this.inverse.x = this.memory.x
                this.inverse.y = this.memory.y
            }

        })

        // Mouse Button Was Released!
        document.getElementById(this.div_id).addEventListener('mouseup', (e) => {

            if (this.debug) console.log('-> mouse : up - dragging : ' + this.dragging)



            // Reset everything to 0
            this.current.x = 0
            this.current.y = 0
            this.memory.x = 0
            this.memory.y = 0
            this.difference.x = 0
            this.difference.y = 0
            this.inverse.x = 0
            this.inverse.y = 0


            if (typeof (this.mouseUpCallback) === 'function') {
                //if (this.debug) console.log('-> mouse : mouseUpCallback ' + this.mouseClick)
                this.mouseUpCallback(this.difference.x, this.difference.y)
            }

            // Mouse button has been released, disable drag state
            this.dragging = false

        })

        // Capture Mouse Move Event
        document.getElementById(this.div_id).addEventListener('mousemove', (e) => {

            // Get the mouse coordinates
            this.current.x = e.pageX
            this.current.y = e.pageY

            // If mouse is currently being dragged
            if (this.dragging) {

                this.difference.x = this.current.x - this.memory.x
                this.difference.y = this.current.y - this.memory.y

                if (this.current.x < this.memory.x)
                    this.inverse.x = this.current.x

                if (this.current.y < this.memory.y)
                    this.inverse.y = this.current.y


                if (typeof (this.mouseDragCallback) === 'function') {
                    //if (this.debug) console.log('-> mouse : mouseDragCallback ' + this.mouseClick)
                    this.mouseDragCallback(this.difference.x, this.difference.y)
                }

                if (this.debug) console.log('-> mouse : dragging ' + this.mouseClick + ' ' + this.difference.x + ':' + this.difference.y)


            }
        })
    }


    /**
     * log (if debug)
     * @param m message
     * @param o output
     */
    log(m, o) {

        if (this.debug) {
            if (o)
                console.log(m, o)
            else
                console.log(m)

        }

    }


    /**
     *
     * @returns {number}
     */
    dragX() {
        return this.difference.x
    }


    /**
     *
     * @returns {number}
     */
    dragY() {
        return this.difference.y
    }


    /**
     *
     * @returns {boolean}
     */
    isClickRight() {
        if (this.mouseClick == 'right')
            return true
        return false
    }


    /**
     *
     * @returns {boolean}
     */
    isClickLeft() {
        if (this.mouseClick == 'left')
            return true
        return false
    }


    isUp() {
        if (this.mouseClick === false)
            return true
        return false
    }


    isDown() {
        if (this.mouseClick === true)
            return true
        return false
    }


    isDragging() {
        return this.dragging
    }


    /**
     *
     * @param f
     */
    setMouseDragCallback(f) {

        if (typeof (f) === 'function') {

            this.log('-> mouse : setMouseDragCallback ' + this.mouseClick)

            this.mouseDragCallback = f

        } else {

            this.log('-> mouse : setMouseDragCallback error')

            this.mouseDragCallback = null

        }

    }

    setMouseUpCallback(f) {

        if (typeof (f) === 'function') {

            this.log('-> mouse : setMouseUpCallback ' + this.mouseClick)

            this.mouseUpCallback = f

        } else {

            this.log('-> mouse : setMouseUpCallback error')

            this.mouseUpCallback = null

        }

    }


}